import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {CommonService} from "../../commons/services/common.service";

@Component({
  selector: 'app-access-ecoportail',
  templateUrl: './access-ecoportail.component.html',
  styleUrls: ['./access-ecoportail.component.css']
})
export class AccessEcoportailComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router, private common: CommonService) {

  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const codeExterneClient = params['params'].id;
      if (!!codeExterneClient && !codeExterneClient.includes('/')) {
        this.common.codeExterneClient = codeExterneClient;
        this.common.local.set('codeExterneClient', codeExterneClient);
      }
      this.router.navigateByUrl('/');
    });
  }

}
